
































import { Lead, LeadService } from "@/services/lead.service";
import DataTable, { TableHeader } from "@/shared/components/data-table.vue";
import { Paginacao } from "@/shared/interface";
import { ServerPageOptions } from "@/shared/utils/datatable";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { dateTime, telefone } from "@/shared/filters";
import { etapaLead, statusLead } from "../filters/filters";

@Component({
  components: {
    DataTable,
  },
  filters: {
    dateTime,
    telefone,
    etapaLead,
    statusLead,
  },
})
export default class DataTablePesquisarLead extends Vue {
  promise: Promise<Paginacao<Lead>> | null = null;

  readonly headers: TableHeader[] = [
    { value: "dataCadastro", text: "Data Criação" },
    { value: "nome", text: "Nome" },
    { value: "telefone", text: "Telefone" },
    { value: "tipoLead.nome", text: "Tipo do Lead", withAliasValue: "tp.nome" },
    {
      value: "canalLead.nome",
      text: "Canal de Prospecção",
      withAliasValue: "cl.nome",
    },
    { value: "idEtapaLead", text: "Etapa do Lead" },
    { value: "idStatusLead", text: "Status do Lead" },
    { value: "dataUltimoStatus", text: "Data Ultimo Status" },
    { value: "usuario.nome", text: "Responsável", withAliasValue: "u.nome" },
  ];

  @Watch("$route", { immediate: true, deep: true })
  onRouteChange(route: Route) {
    const command = route.query;
    this.promise = LeadService.pesquisar(command as any);
  }

  firstTime = true;
  onOptionsChange(options: ServerPageOptions) {
    if (!this.firstTime) {
      const query = Object.assign({}, this.$route.query);

      query.limit = "" + options.limit;
      query.offset = "" + options.offset;
      query.order = options.order;

      this.$router.replace({ query: query });
    }
    this.firstTime = false;
  }

  selecionadoLead(item: Lead) {
    if (item) {
      this.$router.push({
        name: "atendimento-leads",
        params: { idLead: "" + item.idLead },
      });
    }
  }
}
